import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import { getSubdivisions } from '../../../services/taxonomies/subdivisions';

const SubdivisionsList = ({ form, institutionId }) => {
  const [subdivisions, setSubdivisions] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSubdivisions({
          pageSize: 1000,
          deleted: false,
          page: 0,
          criterias: { institutionId },
        });
        setSubdivisions(response.content);
      } catch (error) {
        console.error('Error fetching subdivisions list:', error);
      }
    };

    if (institutionId) {
      fetchData();
    } else {
      setSubdivisions([]);
    }
  }, [form, institutionId]);

  const internalValue = useMemo(() => {
    return form.getFieldValue('Subdiviziune');
  }, [form]);

  const handleChange = useCallback(
    (val) => {
      form.setFieldsValue({ Subdiviziune: val });
    },
    [form],
  );

  return (
    <Select
      allowClear
      value={subdivisions?.length ? internalValue : null}
      onChange={handleChange}
      showSearch
      optionFilterProp="children"
    >
      {subdivisions &&
        subdivisions.map(({ id, name }) => (
          <Select.Option key={id} value={name}>
            {name}
          </Select.Option>
        ))}
    </Select>
  );
};

export default SubdivisionsList;
